// extracted by mini-css-extract-plugin
export default {"brightSpan":"BrightSpan-module__brightSpan_VVdyq"};